// axiosInstance.js
import axios, { AxiosError } from 'axios';
import { Auth } from 'aws-amplify';
import { BAD_REQUEST_STATUS_CODE } from './constants';
import { notification } from 'antd/lib';
import { APP_TERMS } from '../app-terms';
import { API_ENDPOINTS } from './apiEndpoints';
import { getFromLocalStorage } from '../utils/selected-branch-locations';
const PUBLIC_END_POINTS = [API_ENDPOINTS.signUpClinic, API_ENDPOINTS.userStatus]; // Add more public API endpoints here as available
const API_BASE_URL =
  'https://jf8gh0609g.execute-api.us-east-1.amazonaws.com/dev';
const instanceApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

instanceApi.interceptors.request.use(
  async (config) => {
    const url = config.url;
    // Add Authorization header with a valid token for endpoints that are not pulic
    if (PUBLIC_END_POINTS.indexOf(url) === -1) {
      // Set Authorization header
      const session = await Auth.currentSession();
      const idToken = session.getIdToken().getJwtToken();
      if (idToken) config.headers.Authorization = `Bearer ${idToken}`;
      config.headers['Content-Type'] = 'application/json';

      // Set clinicLocationId on params if user selected branch location is available
      const selectedLocation = getFromLocalStorage();
      if (selectedLocation?.clinicLocationId) {
        config.params = { ...(config.params || {}) }; // Incase the params are undefined/null, we need to set an empty object
        config.params['clinicLocationId'] = selectedLocation?.clinicLocationId;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instanceApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error instanceof AxiosError &&
      error?.response?.status === BAD_REQUEST_STATUS_CODE &&
      // When form validation generic message is received, skip global notification
      !error?.response?.data?.formErrorMessage
    ) {
      // To check if error available on data, if yes then notify user with it
      if (error?.response?.data?.error) {
        notification.error({
          message: APP_TERMS.error_title,
          description: error.response.data?.error,
          showProgress: false,
        });
      } else if (error.response.data?.message) {
        // else notify user with message on data
        notification.error({
          message: APP_TERMS.error_title,
          description: error.response.data?.message,
          showProgress: false,
        });
      }
    }
    return Promise.reject(error);
  }
);

export default instanceApi;
